import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ArticleAuthor } from '../ArticleAuthor';
import { ArticleSource } from '../ArticleSource';
import { PublicationDate } from '../PublicationDate';
import { ActionButton } from '../ActionButton';
let ArticleMeta = class ArticleMeta extends Vue {
    get pdfAction() {
        if (!this.pdf) {
            return null;
        }
        return {
            callback: () => {
                if (this.pdfService && this.pdf) {
                    return this.pdfService.download(this.pdf);
                }
            },
            disabled: !this.pdf.path,
            icon: 'download-new',
            title: 'PDF'
        };
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ArticleMeta.prototype, "author", void 0);
__decorate([
    Prop({ type: String, required: true })
], ArticleMeta.prototype, "siteName", void 0);
__decorate([
    Prop({ type: String, required: false, default: null })
], ArticleMeta.prototype, "source", void 0);
__decorate([
    Prop({ type: String, required: false, default: false })
], ArticleMeta.prototype, "publicationDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleMeta.prototype, "hideDate", void 0);
__decorate([
    Prop({ type: Object, required: false, default: null })
], ArticleMeta.prototype, "pdf", void 0);
__decorate([
    Prop({ type: Object, required: false, default: null })
], ArticleMeta.prototype, "pdfService", void 0);
ArticleMeta = __decorate([
    Component({
        name: 'ArticleMeta',
        components: { ActionButton, ArticleAuthor, ArticleSource, PublicationDate },
        template: `
    <div class="article-meta">
      <ArticleAuthor
        class="article-meta__author"
        :author="author"
        :showInitialsWhenNoAvatar="true"
        :hideDate="hideDate"
        :showReadingTime="false"
      />

      <div class="article-meta__meta">
        <PublicationDate v-if="!hideDate" :value="publicationDate" />

        <ArticleSource v-if="source" :source="source" :siteName="siteName" />

        <ActionButton v-if="pdfAction" class="d-md-none" v-bind="pdfAction" />
      </div>
    </div>
  `
    })
], ArticleMeta);
export { ArticleMeta };
